<template>
  <v-container fluid class="login">
    <div class="py-5 app-title font-bold">
      <img src="../../static/img/doe-logo.png" alt="Hawaii DOE Logo">
      <div>OT Service Logs</div>
    </div>
    <v-layout class="mt-5 pb-5" row wrap align-center justify-center>
      <v-flex xs12>
        <div class="login-text">Log in</div>
      </v-flex>
      <v-flex xs10 sm7 md6 lg5 xl4>
        <v-form class="mt-5">
          <v-text-field
            placeholder="Enter your username"
            name="login"
            v-model.trim="username"
            label="Username"
            color="secondary"
            :error-messages="usernameErrors"
            @blur="$v.username.$touch"
            @keyup.enter="onLoginClick"
            autocomplete="off"
            type="text">
          </v-text-field>
          <v-text-field
            placeholder="Enter your password"
            name="password"
            v-model.trim="password"
            label="Password"
            color="secondary"
            :error-messages="passwordErrors"
            @blur="$v.password.$touch"
            @keyup.enter="onLoginClick"
            autocomplete="off"
            type="password">
          </v-text-field>
          <v-alert :value="errorMsg"
                   type="error">
            {{errorMsg}}
          </v-alert>
          <v-btn
            v-on:click.prevent="onLoginClick"
            :disabled="showLoading"
            class="font-bold mt-5"
            color="secondary"
            large
            round
            block>
            Log in
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
    <full-screen-loading-spinner v-if="showLoading"></full-screen-loading-spinner>
  </v-container>
</template>

<script>
/* eslint-disable indent */
  import { required } from 'vuelidate/lib/validators';
  import api from '@/utils/api';
  import * as Constants from '@/constants';
  import JWTHelper from '@/jwt-token';
  import FullScreenLoadingSpinner from '../components/full-screen-loading-spinner';

  export default {
    name: 'Login',
    components: {
      FullScreenLoadingSpinner
    },
    data() {
      return {
        username: '',
        password: '',
        showLoading: false,
        errorMsg: ''
      };
    },
    methods: {
      onLoginClick() {
        this.showLoading = true;
        // set username and password
        const body = {
          username: this.username,
          password: this.password
        };
        let userId;

        api.post(Constants.AUTHENTICATION_URL(), body)
          .then((res) => {
            // update token in local storage, need to change it to cookies
            const token = res.data.data.token;
            localStorage.setItem('user-token', token);
            const user = res.data.data.user;
            // localStorage.setItem('dynatrace-usertag', user.fullName);
            userId = user.userId;
            /**
             * if the user is NOT an admin
             * they can only file SL for themselves
             * set providerId in localStorage to use later
             */
            if (!user.isAdmin) {
              localStorage.setItem('provider-id', userId);
            }
            return api.get(Constants.GET_USER_PREFERENCES_URL(userId));
          })
          .then((pref) => {
            const schedulerRoute = '/scheduler';
            const slRoute = '/dashboard';
            // set the users preference for tooltip
            const helpPreference = pref.data.data.filter((p) => {
              return p.preferenceKey === 'ot_help';
            })[0];
            const showTooltip = helpPreference.value === 'enabled';
            this.$store.commit('tooltip', showTooltip);
            // if the user has full rights to the app, check their preferences
            if (JWTHelper.hasFullRights()) {
              const preferencesArray = pref.data.data;
              // save the user preferences to local storage
              localStorage.setItem('user-preferences', JSON.stringify(preferencesArray));
              // find the view preference in the preference array
              // view preferences will be an array, so take the first record
              const viewPreferences = preferencesArray.filter((preference) => {
                return preference.preferenceKey === 'ot_menu_default';
              })[0];
              if (viewPreferences) {
                // take the user to their set preference
                if (viewPreferences.value === 'schedule') {
                  this.$router.push(schedulerRoute);
                } else if (viewPreferences.value === 'logs') {
                  this.$router.push(slRoute);
                }
              }
            } else if (JWTHelper.hasSchedulerRights()) {
              this.$router.push(schedulerRoute);
            } else if (JWTHelper.hasServiceLogRights()) {
              this.$router.push(slRoute);
            } else {
              throw new Error('This user does not have rights to access this app.');
            }
          })
          .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) {
              this.errorMsg = error.response.data.message;
            } else {
              this.errorMsg = error.message;
            }
          })
          .finally(() => {
            this.showLoading = false;
          });
      }
    },
    computed: {
      usernameErrors() {
        const errors = [];
        if (!this.$v.username.$dirty) return errors;
        if (!this.$v.username.required) errors.push('Username is required.');
        return errors;
      },
      passwordErrors() {
        const errors = [];
        if (!this.$v.password.$dirty) return errors;
        if (!this.$v.password.required) errors.push('Password is required.');
        return errors;
      },
      isMobile() {
        return this.$mq === 'mobile';
      }
    },
    validations: {
      username: {
        required
      },
      password: {
        required
      }
    }
  };
</script>
<style lang="scss" scoped>
  .login {
    padding: 0;
    height: 100vh;
    min-height: 600px;
    .app-title {
      font-family: 'Arvo', serif;
      background-color: #D8E2F6;
      color: var(--v-primary-base);
      text-align: center;
      font-size: 2rem;
      img {
        height: 56px;
      }
    }
    .login-text {
      text-align: center;
      font-size: 2.25rem;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue